<template>
  <BreadCrumb PageTitle="Badges" />
  <BadgesContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import BadgesContent from "../../template-components/UIElements/Badges/BadgesContent.vue";

export default defineComponent({
  name: "BadgesPage",
  components: {
    BreadCrumb,
    BadgesContent,
  },
});
</script>